import { PcDriver } from '@acorn-portal/shared/src/services/subscriptionAPI';

/**
 * Updates the list of drivers to set the main driver based on the provided index.
 *
 * @param drivers - Array of driver objects.
 * @param index - Index of the driver to be set as the main driver.
 * @returns Updated new array of drivers with the main driver set.
 */
export const updateMainDrivers = (storeData: PcDriver[], index: number): PcDriver[] => {
	const clonedStoreData = structuredClone(storeData);
	const updatedDrivers = clonedStoreData.map((item, i) => ({
		...item,
		mainDriver: i === index,
	}));

	return updatedDrivers;
};
